import { gql } from '@apollo/client';
import TENANT_ORDER_OPERATOR from 'api/fragments/TENANT_ORDER_OPERATOR';
const UPDATE_TENANT_ORDER_OPERATOR = gql `
  ${TENANT_ORDER_OPERATOR}
  mutation UpdateOrderOperator($orderOperatorId: ID!, $name: String) {
    updateOrderOperator(orderOperatorId: $orderOperatorId, name: $name) {
      orderOperator {
        ...TenantOrderOperatorFragment
      }
    }
  }
`;
export default UPDATE_TENANT_ORDER_OPERATOR;
